/* Search com Paginação (Load More) */

declare const my_ajax_object: any;

document.addEventListener('DOMContentLoaded', function () {
    const search = document.querySelector('.search') as HTMLElement;
    const searchIcon = document.querySelector('.btn--search') as HTMLElement;
    const closeIcon = document.querySelector('.icon-close') as HTMLElement;
    const searchFormInput = document.querySelector('form.search-form [name=s]') as HTMLInputElement;
    const searchForm = document.querySelector('form.search-form') as HTMLFormElement;
    const searchResults = document.querySelector('.search .results') as HTMLElement;
    const loadMoreButton = document.querySelector('.load-more-button') as HTMLButtonElement | null;

    if (!search || !searchForm || !searchFormInput) return;

    let searchBounce: ReturnType<typeof setTimeout> | null = null;
    let searchAjax: XMLHttpRequest | null = null;
    let lastQuery = '';
    let offset = 0;
    const postsPerPage = 8;

    const textLoadMore = loadMoreButton?.getAttribute('data-text-default') || 'Carregar mais';
    const textLoading = loadMoreButton?.getAttribute('data-text-loading') || 'Carregando...';

    // --- BUSCA INICIAL ---
    const executeSearch = () => {
        const s = searchFormInput.value.trim();

        // Se estiver vazio, reseta para o estado padrão
        if (s.length === 0) {
            lastQuery = '';
            offset = 0;
            if (searchAjax) searchAjax.abort();
            updateSearchState('default');
            if (searchResults) searchResults.innerHTML = '';
            if (loadMoreButton) loadMoreButton.classList.add('hidden');
            return;
        }

        if (s === lastQuery) return;
        lastQuery = s;
        offset = 0; // Reinicia a contagem da paginação

        if (searchAjax) searchAjax.abort();

        updateSearchState('loading');
        if (loadMoreButton) loadMoreButton.classList.add('hidden');

        searchAjax = new XMLHttpRequest();
        searchAjax.open('POST', my_ajax_object.ajax_url, true);
        searchAjax.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

        searchAjax.onload = function () {
            if (this.status === 200) {
                const responseData = this.response ? this.response.trim() : "";

                if (responseData !== "") {
                    if (searchResults) {
                        searchResults.innerHTML = responseData;
                        updateSearchState('results-ok');
                    }
                    offset += postsPerPage;

                    // Exibe o botão de carregar mais se houve resultado
                    if (loadMoreButton) {
                        loadMoreButton.innerText = textLoadMore;
                        loadMoreButton.classList.remove('hidden');
                        loadMoreButton.style.display = 'block';
                    }
                } else {
                    updateSearchState('no-results');
                    if (searchResults) searchResults.innerHTML = '';
                    if (loadMoreButton) loadMoreButton.classList.add('hidden');
                }
            }
        };

        searchAjax.send(`action=search_ajax&s=${encodeURIComponent(s)}&offset=${offset}&posts_per_page=${postsPerPage}`);
    };

    // --- CARREGAR MAIS RESULTADOS ---
    const loadMoreResults = () => {
        const s = searchFormInput.value.trim();
        if (!s || !loadMoreButton) return;

        if (searchAjax) searchAjax.abort();

        loadMoreButton.innerText = textLoading;
        loadMoreButton.disabled = true;

        searchAjax = new XMLHttpRequest();
        searchAjax.open('POST', my_ajax_object.ajax_url, true);
        searchAjax.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

        searchAjax.onload = function () {
            if (loadMoreButton) {
                loadMoreButton.disabled = false;
                loadMoreButton.innerText = textLoadMore;
            }

            if (this.status === 200) {
                const responseData = this.response ? this.response.trim() : "";

                if (responseData !== "") {
                    if (searchResults) {
                        searchResults.insertAdjacentHTML('beforeend', responseData);
                    }
                    offset += postsPerPage;
                } else {
                    // Esconde o botão se não houver mais posts adicionais
                    if (loadMoreButton) {
                        loadMoreButton.classList.add('hidden');
                        loadMoreButton.style.display = 'none';
                    }
                }
            }
        };

        searchAjax.send(`action=search_ajax&s=${encodeURIComponent(s)}&offset=${offset}&posts_per_page=${postsPerPage}`);
    };

    // --- EVENTOS ---

    // Abrir Modal
    searchIcon?.addEventListener('click', function (e) {
        e.preventDefault();
        search.classList.add('active');
        document.body.style.overflow = 'hidden';
        document.body.classList.add('search-open');

        setTimeout(() => searchFormInput.focus(), 300);
    });

    // Fechar Modal
    document.addEventListener('click', function (e) {
        if (e.target === closeIcon || closeIcon?.contains(e.target as Node)) {
            search.classList.remove('active');
            document.body.style.overflow = '';
            document.body.classList.remove('search-open');
        }
    });

    // Digitação (Debounce)
    searchFormInput.addEventListener('keyup', function () {
        if (searchBounce) clearTimeout(searchBounce);
        searchBounce = setTimeout(executeSearch, 400);
    });

    // Submit do formulário
    searchForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        executeSearch();
    });

    // Clique do botão Load More
    loadMoreButton?.addEventListener('click', function (e) {
        e.preventDefault();
        loadMoreResults();
    });
});

// --- CONTROLE DE INTERFACE ---
function updateSearchState(state: string) {
    const loading = document.querySelector('.search .loading') as HTMLElement | null;
    const noContent = document.querySelector('.search .no-content') as HTMLElement | null;
    const defaultMsg = document.querySelector('.search .default') as HTMLElement | null;
    const results = document.querySelector('.search .results') as HTMLElement | null;

    if (loading) loading.style.display = 'none';
    if (noContent) noContent.style.display = 'none';
    if (defaultMsg) defaultMsg.style.display = 'none';

    switch (state) {
        case 'loading':
            if (loading) loading.style.display = 'block';
            if (results) results.style.opacity = '0.4';
            break;
        case 'results-ok':
            if (results) results.style.opacity = '1';
            break;
        case 'no-results':
            if (noContent) noContent.style.display = 'block';
            if (results) results.style.opacity = '1';
            break;
        case 'default':
        default:
            if (defaultMsg) defaultMsg.style.display = 'block';
            if (results) results.style.opacity = '1';
            break;
    }
}
